<template>
    <h4
        class="text-uppercase ls-1 py-3 mb-0"
        :class="classes"
        :style="styles"
        :title="plan.translation.name"
    >
        {{ $trim(plan.translation.name, 45) }}
    </h4>
</template>

<script>
export default {
    props: {
        plan: {
            type: Object,
        },
        content: {
            type: Object,
        },
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        settings() {
            return this.content && this.content.settings;
        },
        showTitle() {
            return this.settings && this.settings.show_title;
        },
        classes() {
            return this.showTitle
                ? ['btn-tooltip']
                : [''];
        },
        styles() {
            return this.showTitle
                ? { color: (this.settings && this.settings.card_text_color)
                    || this.color.secondary,
                }
                : { color: this.color.secondary };
        },
    },
};
</script>
